import { Link } from "@inertiajs/react";
import { ArrowLeft, MessageSquareText } from "lucide-react";
import { ChatbotPreviewPanel, type ChatbotPreviewData } from "@/components/ChatbotPreviewPanel";
import { buttonVariants } from "@/components/ui/button";
import { DashboardLayout } from "@/layouts/DashboardLayout";
import type { PageProps } from "@/types";

interface Props extends PageProps, ChatbotPreviewData {
  business: { id: number; name: string } | null;
}

export default function ChatbotPreviewShow({
  business,
  messages,
  limits,
  current_user,
  current_organization,
  current_business,
  org_slug,
}: Props) {
  if (!current_user || !org_slug) return null;

  return (
    <DashboardLayout
      currentUser={current_user}
      currentOrganization={current_organization}
      currentBusiness={current_business}
      orgSlug={org_slug}
    >
      <div className="mx-auto max-w-4xl space-y-5">
        <div className="space-y-2">
          <Link href={`/${org_slug}/settings`} className={buttonVariants({ variant: "ghost", size: "sm" })}>
            <ArrowLeft className="mr-1 h-4 w-4" />
            Volver a Configuración
          </Link>
          <div>
            <h1 className="flex items-center gap-2 text-2xl font-semibold text-foreground">
              <MessageSquareText className="h-6 w-6" />
              Probar agente
            </h1>
            <p className="text-sm text-muted-foreground">
              Conversa como cliente usando la configuración real de {business?.name || "tu negocio"}.
            </p>
          </div>
        </div>

        <ChatbotPreviewPanel
          business={business}
          messages={messages}
          limits={limits}
          messagePath={`/${org_slug}/chatbot_preview/messages`}
          resetPath={`/${org_slug}/chatbot_preview`}
          title={business?.name}
        />
      </div>
    </DashboardLayout>
  );
}
